/*
 * @创建文件时间: 2019-12-09 11:15:36
 * @Auther: lfq
 * @最后修改人: lfq
 * @最后修改时间: 2020-06-23 11:20:59
 * @联系Qq:1638245306
 * @文件介绍: 人事管理模块
 */
export default [{
    path: 'hrBasicInfo',
    name: 'hrBasicInfo',
    meta: {
        title: '人事基本信息',
        auth: true
    },
    component: () =>
        import ('@/views/basic/personal/hrBasicInfo')
}, {
    path: 'dictionary',
    name: 'dictionary',
    meta: {
        title: '人事字典',
        auth: true
    },
    component: () =>
        import ('@/views/basic/personal/dictionary')
}, {
    path: 'personOrganize',
    name: 'personOrganize',
    meta: {
        title: '人事组织机构',
        auth: true
    },
    component: () =>
        import ('@/views/basic/personal/personOrganize')
}, {
    path: 'hrMonthlyWages',
    name: 'hrMonthlyWages',
    meta: {
        title: '工资月报表',
        auth: true
    },
    component: () =>
        import ('@/views/basic/personal/hrMonthlyWages/index')
}]